module.exports = __webpack_public_path__ + "static/media/default-man-inky.f571c1e0.png";